import { ChevronRightSVG } from '@sbercloud/uikit-product-icons';
import { ButtonFunction } from '@snack-uikit/button';
import styles from "./styles.module.css";
import { jsx as _jsx } from "react/jsx-runtime";
export function SectionCatalogFooter(_ref) {
  var items = _ref.items,
    layoutType = _ref.layoutType;
  if (items.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    className: styles.footer,
    "data-layout-type": layoutType,
    children: items.map(function (_ref2) {
      var label = _ref2.label,
        onClick = _ref2.onClick,
        href = _ref2.href;
      return /*#__PURE__*/_jsx(ButtonFunction, {
        label: label,
        size: "m",
        onClick: onClick,
        href: href,
        icon: /*#__PURE__*/_jsx(ChevronRightSVG, {})
      }, label);
    })
  });
}